import { get } from '../../../utilities/http'
import {
    getProductCode,
    getProductDescription,
    getProductName
} from '../../../utilities/productDisplay'
import storage, { formPresentation, tablePresentations } from '../storage'
import { GroupPresentationInfo } from '../types'

export default async function loadGroupPresentation(groupPresentationId) {
    const { data, error } = await get<GroupPresentationInfo>(
        `/v5.6/apis/group_presentations/${groupPresentationId}`
    )
    if (error) return null
    storage.currentGroupPresentation = data.result
    const { name, presentation_products } = data.result
    storage.products.sets(
        presentation_products.map(pp => ({
            id: pp.product_id,
            code: getProductCode(pp.product),
            description: getProductDescription(pp.product),
            amount: pp.amount.toString()
        }))
    )
    formPresentation.init({
        name,
        presentationProducts: presentation_products.map(pp => ({
            label: getProductName(pp.product),
            value: pp.product_id.toString()
        }))
    })
    tablePresentations.setList(
        presentation_products.map(pp => ({
            id: pp.product_id,
            description: getProductDescription(pp.product),
            code: getProductCode(pp.product),
            amount: pp.amount.toString()
        }))
    )

    return data.result
}
